import { render, staticRenderFns } from "./SpecialPriceAdjNew_Scanner.vue?vue&type=template&id=945d22cc&"
import script from "./SpecialPriceAdjNew_Scanner.vue?vue&type=script&lang=js&"
export * from "./SpecialPriceAdjNew_Scanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports